/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsPackingHistoryVo } from './GoodsPackingHistoryVo';
import {
    GoodsPackingHistoryVoFromJSON,
    GoodsPackingHistoryVoFromJSONTyped,
    GoodsPackingHistoryVoToJSON,
    GoodsPackingHistoryVoToJSONTyped,
} from './GoodsPackingHistoryVo';

/**
 * 
 * @export
 * @interface ResponseGoodsPackingHistoryVo
 */
export interface ResponseGoodsPackingHistoryVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGoodsPackingHistoryVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGoodsPackingHistoryVo
     */
    message?: string;
    /**
     * 
     * @type {GoodsPackingHistoryVo}
     * @memberof ResponseGoodsPackingHistoryVo
     */
    data?: GoodsPackingHistoryVo;
}

/**
 * Check if a given object implements the ResponseGoodsPackingHistoryVo interface.
 */
export function instanceOfResponseGoodsPackingHistoryVo(value: object): value is ResponseGoodsPackingHistoryVo {
    return true;
}

export function ResponseGoodsPackingHistoryVoFromJSON(json: any): ResponseGoodsPackingHistoryVo {
    return ResponseGoodsPackingHistoryVoFromJSONTyped(json, false);
}

export function ResponseGoodsPackingHistoryVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGoodsPackingHistoryVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GoodsPackingHistoryVoFromJSON(json['data']),
    };
}

export function ResponseGoodsPackingHistoryVoToJSON(json: any): ResponseGoodsPackingHistoryVo {
    return ResponseGoodsPackingHistoryVoToJSONTyped(json, false);
}

export function ResponseGoodsPackingHistoryVoToJSONTyped(value?: ResponseGoodsPackingHistoryVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GoodsPackingHistoryVoToJSON(value['data']),
    };
}

